import React from "react";
import styles from "./discomfortScale.module.css";


const emojiScale = ["😀", "😊", "🙂", "😐", "😕", "😟", "😣", "😖", "😫", "😩", "😭"];

const DiscomfortScale = props => {
  return (
    <div className={styles.scaleBox}>
      <h2 className={styles.scaleTitle}>
        {props.scaleTitle}
      </h2>
      <div >
        {/* Emoji Row */}
        <div className={styles.scale}>
          {emojiScale.map((emoji, index) => (
            <div
              key={index}
              className={`${styles.scaleItem} ${styles[`color-${index}`]}`}
            >
              <span className={styles.emoji}>{emoji}</span>
              <span className={styles.number}>{index}</span>
            </div>
          ))}
        </div>

        {/* Labels */}
        <div className={styles.labels}>
          <span>0 - {props.scaleZero}</span>
          <span>{props.scaleTen} - 10</span>
        </div>
      </div>
    </div>
  );
};

export default DiscomfortScale;